/// <amd-module name="TFS/Views/ProjectOverviewPage/Constants" />
export const enum Constants {
    Area = "ProjectOverviewPage",
    ProjectOverviewTabKey = "overview"
}

export const enum PerformanceConstants {
    ProjectOverviewTtiFeatureName = "ProjectOverviewPage.Loaded"
}

export const enum ProjectOverviewPageScenarios {
    GetOverviewPageData = "ProjectOverviewPageDataProviderSource.GetProjectOverviewPageData"
}

export const enum ProjectMembersScenarios {
    GetProjectMembers = "ProjectMembersSource.GetProjectMembers"
}

export const enum TelemetryConstants {
    Event = "Event",
    Failed = "Failed",
    InviteButtonClick = "InviteButtonClick",
    EditNameButtonClick = "EditNameButtonClick",
    ProjectId = "ProjectId",
    RepositoryId = "RepositoryId",
    RepositoryType = "RepoType",
    Status = "Status",
    Source = "Source",
    Succeeded = "Succeeded",
    Tab = "Tab"
}
